'use client'

import type React from 'react'
import { cn } from '../../../shared/cn'
import { P3 } from '../../typography/Paragraph'
import { colors } from './badgeStyles'

// type LabelComponentType = typeof Label1 | typeof Label2 | typeof Label3

export type BadgeProps = Omit<React.ComponentPropsWithoutRef<'span'>, 'size'> & {
  color?: keyof typeof colors
  // size?: 1 | 2 | 3
}

export function Badge({ color = 'default', className, ...props }: BadgeProps) {
  // const LabelComponent: LabelComponentType = size === 1 ? Label1 : size === 2 ? Label2 : Label3

  return (
    <P3
      {...props}
      className={cn(
        'inline-flex h-fit items-center justify-center gap-x-1 text-nowrap rounded-full px-1.5 py-1 leading-4.5',
        color && colors[color],
        className
      )}
    />
  )
}

export { colors } from './badgeStyles'
